// DISPLAY-ONLY option-symbol formatter.
// "NIFTY2661624000CE" → "NIFTY 16th JUN 24000 CE".
//
// Safe to wrap around any rendered string: if the value isn't a recognisable option
// trading symbol it is returned UNCHANGED (equities, indices, blanks all pass through).
// NEVER use the output as a key, an API argument, or for any data lookup/calculation —
// the raw symbol must stay intact for the backtester / data layer.

const UND = ["BANKNIFTY", "MIDCPNIFTY", "FINNIFTY", "NIFTY", "SENSEX"]; // longest first
const MON = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
const ord = (d) => { const s = ["th", "st", "nd", "rd"], v = d % 100; return d + (s[(v - 20) % 10] || s[v] || s[0]); };

export function formatOptionSymbol(raw) {
  if (!raw || typeof raw !== "string") return raw;
  const s = raw.toUpperCase();
  const und = UND.find((u) => s.startsWith(u));
  if (!und) return raw;
  const m = /^(\d{2})([1-9OND])(\d{2})(\d+)(CE|PE)$/.exec(s.slice(und.length));
  if (!m) return raw;
  const moC = m[2];
  const mo = moC === "O" ? 10 : moC === "N" ? 11 : moC === "D" ? 12 : Number(moC);
  if (!(mo >= 1 && mo <= 12)) return raw;
  const day = Number(m[3]);
  return `${und} ${ord(day)} ${MON[mo - 1]} ${m[4]} ${m[5]}`;
}

// Parse a real NSE option trading symbol into its parts (mirrors the backend's
// parseOptionSymbol in routes/optionChart.js): {UND}{yy}{moCode}{dd}{strike}{CE|PE},
// where moCode is 1-9 or O/N/D for Oct/Nov/Dec. Returns null on anything that isn't a
// recognisable option symbol (equities, indices, crypto, blanks).
//   "NIFTY2580724000CE" → { underlying:"NIFTY", expiry:"2025-08-07", strike:24000, optType:"CE" }
export function parseOptionSymbol(raw) {
  if (!raw || typeof raw !== "string") return null;
  const s = raw.toUpperCase();
  const und = UND.find((u) => s.startsWith(u));
  if (!und) return null;
  const m = /^(\d{2})([1-9OND])(\d{2})(\d+)(CE|PE)$/.exec(s.slice(und.length));
  if (!m) return null;
  const [, yy, moC, dd, strike, optType] = m;
  const mo = moC === "O" ? 10 : moC === "N" ? 11 : moC === "D" ? 12 : Number(moC);
  const day = Number(dd);
  if (!(mo >= 1 && mo <= 12) || !(day >= 1 && day <= 31)) return null;
  const expiry = `20${yy}-${String(mo).padStart(2, "0")}-${dd}`;
  return { underlying: und, expiry, strike: Number(strike), optType, symbol: und + s.slice(und.length) };
}

// True only for a real NSE option trading symbol (UND + yy + month + dd + strike + CE/PE),
// e.g. "NIFTY2661623200CE". Used to decide whether a leg's symbol can be opened directly
// as an option chart (vs. an equity/crypto symbol that has no option-chart endpoint).
export function isOptionSymbol(raw) {
  return parseOptionSymbol(raw) != null;
}
